module.exports = __webpack_public_path__ + "img/SE5144007399.06e98cd8.png";